import { editStoreBuilder } from '@/main/store/pages/edit/builder';

import { NAME, CRUMB_LABEL_KEY } from '../constants';
import { apiProvider } from '../api';

const edit = {
	EditDat: null as Date | null,
	EditPracId: null as number | null,
	EditPracIdText: null as string | null,
	LockedPrp: null as boolean | null,
	Poznamka: null as string | null,
	Text: null as string | null,
	TextPfxPrp: null as boolean | null,
	TextPrp: null as boolean | null,
	TextSfxPrp: null as boolean | null,
	VozzavadatextId: null as number | null,
	VozzavtypPzn: null as number | null,
	VstupDat: null as Date | null,
	VstupPracId: null as number | null,
	VstupPracIdText: null as string | null,
};

export const store = editStoreBuilder({
	name: NAME,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {	VozzavtypPzn: [] },
	depTableNames: [],
	depTableSettings: {},
	edit,
	localState: {},
	extraActions: {},
	extraMutations: {},
	extraGetters: {},
	props: {
		filter: {},
		mode: null,
	},
});
